import { FilterActions, FilterVariant } from "@next-platform/client-common-spicy-ui";
import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";

import { DEFINITION_SIZE_CATEGORY_VALUES } from "@/components/search/definitionSizeCategoryValues";

const toVariant = ({ isRefined, isExcluded }: { isRefined?: boolean; isExcluded?: boolean }) => {
  if (isExcluded) return FilterVariant.EXCLUDE;
  if (isRefined) return FilterVariant.INCLUDE;
  return FilterVariant.DEFAULT;
};

const normalizeDefinitionName = (label: string) => (label ?? "").trim().toLowerCase();

const orderIndex = (value: string) => {
  const normalizedValue = value.toLowerCase();
  const index = DEFINITION_SIZE_CATEGORY_VALUES.findIndex((categoryValue) => categoryValue === normalizedValue);
  return index === -1 ? Number.MAX_SAFE_INTEGER : index;
};

export default function generateDefinitionData(
  items: RefinementListItem[],
  actionHandler: (action: FilterActions, value?: string) => void,
  translateLabel: (normalizedDefinitionLabel: string) => string,
) {
  const sorted = items.slice().sort((itemA, itemB) => {
    const ac = itemA.count ?? 0;
    const bc = itemB.count ?? 0;
    if (bc !== ac) return bc - ac;

    const ai = orderIndex(itemA.label);
    const bi = orderIndex(itemB.label);
    if (ai !== bi) return ai - bi;

    return normalizeDefinitionName(itemA.label).localeCompare(normalizeDefinitionName(itemB.label));
  });

  return sorted.map((refinementListItem: RefinementListItem) => {
    const sizeSource = refinementListItem.value || refinementListItem.label;
    const label = translateLabel(normalizeDefinitionName(sizeSource));
    const count = refinementListItem.count ?? 0;

    return {
      label,
      count,
      value: refinementListItem.value,
      variant: toVariant(refinementListItem),
      disabled: count === 0,
      actionHandler,
    };
  });
}
